// src/services/geo.service.js
import api from './api';

const geoService = {
  getStates: async () => {
    const res = await api.get('/geo/states');
    return res.data;
  },

  getDistricts: async (state) => {
    const res = await api.get('/geo/districts', { params: { state } });
    return res.data;
  },

  getTalukas: async (state, district) => {
    const res = await api.get('/geo/talukas', { params: { state, district } });
    return res.data;
  },

  getVillages: async (state, district, taluka, search) => {
    const params = { state, district, taluka };
    if (search) params.search = search;
    const res = await api.get('/geo/villages', { params });
    return res.data;
  },
  
   addManualVillage: async ({ name, stateName, districtName, talukaName, villageCode }) => {
    const res = await api.post('geo/villages/manual', {
      name,
      stateName,
      districtName,
      talukaName,
      villageCode,
    });
    return res.data;
  }
};

export default geoService;